import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AffiliateTracker() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const ref = searchParams.get('ref');
    if (!ref) return;

    const code = ref.toUpperCase();
    // Store in session for use at checkout
    sessionStorage.setItem('fpm_affiliate_code', code);

    // Track the click
    fetch(`${BACKEND_URL}/api/affiliates/${code}/click`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        code,
        page_url: window.location.href,
        referrer: document.referrer || 'direct',
      }),
    }).catch(() => {}); // Silent fail - tracking is non-critical
  }, [searchParams]);

  return null; // This is a utility component, renders nothing
}
